function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "8o3vly15oa"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#8o3vly15oa)",
  transform: "translate(-310 -13) translate(310 13)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.645 15.105c-3.01 0-5.46-2.45-5.46-5.46 0-3.011 2.45-5.461 5.46-5.461s5.46 2.45 5.46 5.46c0 3.011-2.45 5.461-5.46 5.461zM22 20.455l-6.239-6.238c.956-1.277 1.529-2.856 1.529-4.572C17.29 5.423 13.867 2 9.645 2 5.423 2 2 5.423 2 9.645c0 4.222 3.423 7.645 7.645 7.645 1.716 0 3.296-.573 4.572-1.529L20.456 22 22 20.456z"
}))));

function SvgIconCustomSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomSearch);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxkZWZzPgogICAgICAgIDxmaWx0ZXIgaWQ9IjhvM3ZseTE1b2EiPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDAuMTA1ODgyIDAgMCAwIDAgMC4xMDk4MDQgMCAwIDAgMCAwLjExMzcyNSAwIDAgMCAxLjAwMDAwMCAwIi8+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnPgogICAgICAgICAgICA8ZyBmaWx0ZXI9InVybCgjOG8zdmx5MTVvYSkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMTAgLTEzKSB0cmFuc2xhdGUoMzEwIDEzKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNOS42NDUgMTUuMTA1Yy0zLjAxIDAtNS40Ni0yLjQ1LTUuNDYtNS40NiAwLTMuMDExIDIuNDUtNS40NjEgNS40Ni01LjQ2MXM1LjQ2IDIuNDUgNS40NiA1LjQ2YzAgMy4wMTEtMi40NSA1LjQ2MS01LjQ2IDUuNDYxek0yMiAyMC40NTVsLTYuMjM5LTYuMjM4Yy45NTYtMS4yNzcgMS41MjktMi44NTYgMS41MjktNC41NzJDMTcuMjkgNS40MjMgMTMuODY3IDIgOS42NDUgMiA1LjQyMyAyIDIgNS40MjMgMiA5LjY0NWMwIDQuMjIyIDMuNDIzIDcuNjQ1IDcuNjQ1IDcuNjQ1IDEuNzE2IDAgMy4yOTYtLjU3MyA0LjU3Mi0xLjUyOUwyMC40NTYgMjIgMjIgMjAuNDU2eiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };